import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminTransactionsTableColumns";
import moment from "moment-jalaali";


function AdminTransactionsListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
}) {
  const [tableData, setTableData] = useState([]);
  const { getTransactionsCount: count, getTransactions: transactions } = data;

  useEffect(() => {
    const initialTableData = [];
    transactions.map((transaction) => {
      const {
        id,
        createdAt,
        updatedAt,
        amount,
        description,
        user
      } = transaction;
      initialTableData.push({
        key: id,
        createdTime: moment(createdAt).format("HH:mm"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        amount: 
        amount < 0 ? (
          <p style={{ color: "red", direction: "ltr" }}>
            {amount.toLocaleString()}
          </p>
        ) : (
          <p>{amount.toLocaleString()}</p>
        ),
        description,
        payer: user.name,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id, user.name)}>
              <EyeOutlined />
            </a>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [transactions]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x:600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminTransactionsListTable;
